import {useCallback, useEffect, useState} from "react";
import {FieldArrayWithId} from "react-hook-form";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {ID_COLLECT_VOYAGE} from "views/ProcessDetails/utils/constants";

export const useVoyageAccordion = (
  voyages: FieldArrayWithId<Process, "boarding.voyages", "idForm">[],
) => {
  const [expanded, setExpanded] = useState<Set<string>>(new Set());

  const toggleAccordion = useCallback((panelId: string) => {
    setExpanded((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(panelId)) {
        newSet.delete(panelId);
      } else {
        newSet.add(panelId);
      }
      return newSet;
    });
  }, []);

  const isExpanded = useCallback(
    (panelId: string) => {
      return expanded.has(panelId);
    },
    [expanded],
  );

  // expande viagem atual, primeira não desembarcada
  useEffect(() => {
    const activeVoyage = voyages.find(
      (voyage) =>
        voyage.typeVoyage?.id !== ID_COLLECT_VOYAGE && !voyage.cargoUnload,
    );
    if (activeVoyage?.idForm && expanded.size === 0) {
      setExpanded(new Set([activeVoyage.idForm]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voyages]);

  return {
    expanded,
    toggleAccordion,
    isExpanded,
  };
};
